export const API_MINOR_VERSION = 3;
export const API_MAJOR_VERSION = 'v5'
export const API_PROVIDER = 'hungryhub';
export const API_BASE_URL = '/api'